import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import RCTooltip from 'rc-tooltip';
import { TooltipProps as RCTooltipProps } from 'rc-tooltip/lib/Tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import styles from './index.less';


export interface TooltipProps extends Omit<RCTooltipProps, 'overlay'> {
  title: ReactNode;
  type?: 'default' | 'white';
}

const Tooltip: FC<TooltipProps> = ({ overlayClassName, title, type = 'default', ...props }) =>
  <RCTooltip
    {...props}
    overlay={title}
    overlayClassName={classNames(styles.overlay, overlayClassName, styles[type])}
  />

export default Tooltip;
